export const termsKeys = {
  all: ["terms"] as const,
  details: () => [...termsKeys.all, "detail"] as const,
  detail: (terms_archive_loc: string | null) =>
    [...termsKeys.details(), terms_archive_loc] as const,
}
